export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_URL || '/api',
    TIMEOUT: 30000,
};

export const ROLES = {
    USER: 'user',
    MANAGER: 'manager',
    CURATOR: 'curator',
    ADMIN: 'admin',
    TOP_BOSS: 'top_boss',
};

export const DIALOG_STATUS = {
    ACTIVE: 'active',
    COMPLETED: 'completed',
    ARCHIVED: 'archived',
};

export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    PROFILE: '/profile',
    ADMIN: '/admin',
    MANAGER: '/manager',
    SCENARIOS: '/scenarios',
    CHAT: '/chat',
    ACHIEVEMENTS: '/achievements',
};
